const UserListIcon = ({ active }) => {
  const color = active ? "#0149AD" : "#545454";
  return (
    <svg
      width="15"
      height="14"
      viewBox="0 0 15 14"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M3.17543 9.06024C2.41401 9.52094 0.417609 10.4616 1.63355 11.6387C2.22753 12.2138 2.88907 12.625 3.72078 12.625H8.46672C9.29843 12.625 9.95997 12.2138 10.5539 11.6387C11.7699 10.4616 9.77349 9.52094 9.01207 9.06024C7.22655 7.97992 4.96095 7.97992 3.17543 9.06024Z"
        stroke={color}
        stroke-linecap="round"
        stroke-linejoin="round"
      />
      <path
        d="M8.4375 3.875C8.4375 5.25571 7.31821 6.375 5.9375 6.375C4.55679 6.375 3.4375 5.25571 3.4375 3.875C3.4375 2.49429 4.55679 1.375 5.9375 1.375C7.31821 1.375 8.4375 2.49429 8.4375 3.875Z"
        stroke={color}
      />
      <path
        d="M10.625 2.625L13.75 2.625"
        stroke={color}
        stroke-linecap="round"
        stroke-linejoin="round"
      />
      <path
        d="M10.625 4.5L13.75 4.5"
        stroke={color}
        stroke-linecap="round"
        stroke-linejoin="round"
      />
      <path
        d="M12.5 6.375L13.75 6.375"
        stroke={color}
        stroke-linecap="round"
        stroke-linejoin="round"
      />
    </svg>
  );
};

export default UserListIcon;
